import { KeyboardEvent } from 'react';

export const handleEnterKeyPress = (evt: KeyboardEvent, callback: () => void) => {
  if (evt.keyCode === 13) {
    evt.preventDefault();
    callback();
  }
};
